<template>
  <span>
    In the event you return qualifying item(s), please be sure to include the bonus with the return. If you would like to keep the bonus but not the
    qualifying item(s), your account will be charged for the value of the bonus.
  </span>
</template>
